module.exports = __webpack_public_path__ + "img/educacao.df6638b3.svg";